import { question } from "./SMSTpv.types"
export const generateSaveAnswerPayload = (payload: question[]) => {
  return payload.map(
    ({ id, questionType, question, isYes, isNo, dtmfAnswer }: question) => {
      const payload = {
        questionId: id,
        questionType,
        questionDescription: question,
      }
      if (questionType === 'SPEECH_ONLY') {
        return {
          ...payload,
          description: "" //same state used for speech only
        }
      } else if (questionType === 'VOICE_RESPONSE') {
        return {
          ...payload,
          description: dtmfAnswer //same state used for speech only
        }
      }
      else if (questionType === 'YESNO') {
        return {
          ...payload,
          description: isYes ? 'yes.' : 'no.',
        }
      } else if (questionType === 'DTMF') {
        return {
          ...payload,
          description: dtmfAnswer,
        }
      } else if (questionType === 'BOTH_OPTION') {
        if (isYes || isNo) {
          return {
            ...payload,
            description: isYes ? 'yes.' : 'no.',
          }
        } else {
          return {
            ...payload,
            description: dtmfAnswer,
          }
        }
      }
    }
  )
}